import { render, staticRenderFns } from "./PedidoKanbanCard.vue?vue&type=template&id=a932fcca&scoped=true"
import script from "./PedidoKanbanCard.vue?vue&type=script&lang=js"
export * from "./PedidoKanbanCard.vue?vue&type=script&lang=js"
import style0 from "./PedidoKanbanCard.vue?vue&type=style&index=0&id=a932fcca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a932fcca",
  null
  
)

export default component.exports